<template>

  <div class="card mt-6" style="clear: both">
    <p class="title is-5 is-pulled-left mt-7 ml-7">Magazines</p>
    <div class="mt-6 mr-6" style="float:right">
      <modal-opener-full
        :component="require('./MagazineModal').default"
        @reload="reloadComponent"
      >
        <button slot="trigger" class="button is-primary is-outlined mb-6">
          <b-icon icon="plus" style="height: 100%"></b-icon>
          <span>Add Magazine</span>
        </button>
      </modal-opener-full>
    </div>
    <div class="card-content">
      <b-table
        :data="magazines.data"
        :loading="magazines.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :current-page="magazines.current_page"
        :per-page="magazines.per_page"
        :total="magazines.total"
        @page-change="(page) => magazines.changePage(page)"
        backend-sorting
        :default-sort="['id', 'desc']"
        class="is-middle"
      >
        <template slot-scope="{ row: magazine }">
          <b-table-column label="Magazine Id">
            <router-link :to="`/magazine/magazines/${magazine.magazine_id}/edit`">{{
                magazine.magazine_id
              }}
            </router-link>
          </b-table-column>
          <b-table-column label="Name">{{
              magazine.name
            }}
          </b-table-column>

          <b-table-column label="Created at">{{
              magazine.created_at
            }}
          </b-table-column>

          <b-table-column width="5" centered>
            <button class="button is-danger is-outlined" @click="deleteMagazine" :value='magazine.id'>Remove</button>
          </b-table-column>
        </template>

        <template slot="empty">
          <empty-message></empty-message>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      magazines: new window.PaginatedRemoteCollection(
        () => `/admin/api/wifi/vendors/${this.$route.params.id}/magazines`
      ).load()
    };
  },

  methods: {
    deleteMagazine(event) {
      let form = new window.Form();
      form.delete(
        `/admin/api/wifi/vendors/${this.$route.params.id}/magazines/${event.target.value}`
      ).then(() => {
        this.$buefy.toast.open('Magazine removed')
        this.reloadComponent('magazine')
      })
      event.path[2].remove();
    },
    reloadComponent(value){
      this.$emit('reload', value)
    }
  }
}
</script>
